import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, useDataOne, use, useTranslate, } from "@bluelibs/x-ui";
import { ObjectId } from "@bluelibs/ejson";
import { UsersCollection } from "@bundles/UIAppBundle/collections";
import { UserViewer } from "../../config/UserViewer";
import { features } from "../../config/features";
export function UsersView(props) {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const collection = use(UsersCollection);
    // If you want to benefit of live data features use useLiveData()
    const { data: document, isLoading, error, } = useDataOne(UsersCollection, new ObjectId(props.id), UserViewer.getRequestBody());
    let content;
    if (isLoading) {
        content = (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0));
    }
    else {
        if (error || document === null) {
            content = (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" }, void 0));
        }
        else {
            content = _jsx(UsersViewComponent, { document: document }, void 0);
        }
    }
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white" }, { children: [_jsx(Ant.PageHeader, { title: t("management.users.view.header"), onBack: () => window.history.back(), extra: getHeaderActions(collection, router, props.id) }, void 0), _jsx(Ant.Card, { children: content }, void 0)] }), void 0) }, void 0));
}
export function UsersViewComponent(props) {
    const document = props.document;
    const viewer = use(UserViewer, { transient: true });
    viewer.setDocument(document);
    viewer.build();
    return (_jsx(Ant.Descriptions, Object.assign({ column: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 3 } }, { children: viewer.rest().map((item) => {
            return (_jsx(Ant.Descriptions.Item, Object.assign({ label: item.label }, { children: viewer.render(item) }), item.id));
        }) }), void 0));
}
export function getHeaderActions(collection, router, id) {
    const actions = [];
    const t = useTranslate();
    if (features.edit) {
        actions.push(_jsx(Link, Object.assign({ to: router.path(Routes.USERS_EDIT, {
                params: { id },
            }) }, { children: _jsx(Ant.Button, { children: t("generics.edit") }, void 0) }), "edit"));
    }
    if (features.delete) {
        actions.push(_jsx(Ant.Popconfirm, Object.assign({ title: t("management.users.delete_question"), onConfirm: () => {
                collection.deleteOne(id).then(() => {
                    router.go(Routes.USERS_LIST);
                    Ant.notification.success({
                        message: t("generics.success"),
                        description: t("management.users.delete_confirmation"),
                    });
                });
            } }, { children: _jsx(Ant.Button, Object.assign({ className: "ant-btn-danger" }, { children: t("generics.delete") }), void 0) }), "delete"));
    }
    const viewRoutePath = router.path(Routes.USERS_VIEW, {
        params: { id },
    });
    return actions;
}
